import classes from './TeamComponents.module.css'
import ActiveRound from '../../stories/Round/ActiveRound'
import { useTeamStats } from '../api'
import MatchesPerformanceOverview from '../../stories/PerformanceOverview/MatchesPerformanceOverview'
import MatchSummary from '../../stories/MatchSummary/MatchSummary'
import { useMediaQuery } from '@mantine/hooks'
import { useParams } from 'react-router'
import { Typography } from '../../common/typography'
import { useMatches } from '../../matches/api'

export default function TeamMatches() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const { competitionId, teamId } = useParams()

  const { data: team_stats } = useTeamStats({
    competition_id: Number(competitionId),
    team_id: Number(teamId),
  })

  const { data: team_matches } = useMatches({
    competition_id: Number(competitionId),
    team_id: Number(teamId),
  })
  const liveMatch = team_matches.find((m) => m.round_status === 'live')

  return (
    <div className={classes.teamMatchesContainer}>
      {isDesktop && (
        <Typography
          level={3}
          fs="xl"
          fw={500}
          fc={{ light: 'black', dark: 'gray-3' }}
          lh="100"
        >
          Weekly Matches: Team Performance Overview
        </Typography>
      )}
      <div className={classes.teamMatchesWrapper}>
        {liveMatch && (
          <div className={classes.endedRoundWrapper}>
            <ActiveRound match={liveMatch} />
          </div>
        )}
        <div className={classes.performanceOverviewWrapper}>
          <MatchesPerformanceOverview
            stats={team_stats}
            title={
              isDesktop
                ? undefined
                : 'Weekly Matches: Team Performance Overview'
            }
          />
        </div>
      </div>
      <MatchSummary
        teamId={parseInt(teamId || '0', 10)}
        competitionId={parseInt(competitionId || '0', 10)}
        summary_title="Match Form Summary"
        isDesktop={isDesktop}
      />
    </div>
  )
}
